import { inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export abstract class DialogBase<TComponent, TData = unknown> {
    protected readonly dialog = inject<MatDialogRef<TComponent>>(MatDialogRef);
    readonly data = inject<TData>(MAT_DIALOG_DATA);

    protected close(result?: unknown): void {
        this.dialog.close(result);
    }
}